module.exports = __webpack_public_path__ + "static/media/Liuna-1059-Logo_STACKED.8fc3ef40.svg";